/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class QuickLink implements IDirective {
        public controller = ["$scope", QuickLinkController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/quickLink.html';
        public restrict: string = "E";

        public scope: any = {
            processConfigId: "=",
            componentUrlPart: "@",
            componentId: "="
        };

        public link(scope: IQuickLinkScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: QuickLinkController): void {
        }
    }

    export interface IQuickLinkScope extends ng.IScope {
        processConfigId: string;
        componentUrlPart: string;
        componentId: string;
    }

    export class QuickLinkController implements IController {
        constructor(private $scope: IQuickLinkScope) { }
    }
}

warsApp.registerDirective('QuickLink', []);